import React from 'react';

export interface RecipeCalculationRow {
  id: number;
  name: string;
  grossWeight: number;
  netWeight: number;
  output: number;
  piecesPerPortion?: number | null;
}

interface RecipeCalculationCardProps {
  title: string;
  rows: RecipeCalculationRow[];
}

const RecipeCalculationCard: React.FC<RecipeCalculationCardProps> = ({ title, rows }) => {
  const totals = rows.reduce(
    (sum, row) => ({
      grossWeight: sum.grossWeight + row.grossWeight,
      netWeight: sum.netWeight + row.netWeight,
      output: sum.output + row.output,
    }),
    { grossWeight: 0, netWeight: 0, output: 0 }
  );

  return (
    <section className="recipe-calculation-card" aria-label={title}>
      <h4>{title}</h4>
      {rows.length === 0 ? (
        <p className="recipe-calculation-card__empty">Склад не заповнений.</p>
      ) : (
        <div className="recipe-calculation-card__table-wrap">
          <table className="recipe-calculation-card__table">
            <thead>
              <tr>
                <th scope="col">Інгредієнт</th>
                <th scope="col">Брутто</th>
                <th scope="col">Нетто / шт.</th>
                <th scope="col">Вихід</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td data-label="Інгредієнт" className="recipe-calculation-card__name">{row.name || '—'}</td>
                  <td data-label="Брутто">{row.grossWeight.toFixed(3)}</td>
                  <td data-label="Нетто / шт.">
                    {row.netWeight.toFixed(3)}
                    {row.piecesPerPortion != null && row.piecesPerPortion > 0
                      ? ` · ${row.piecesPerPortion.toFixed(3)} шт.`
                      : ''}
                  </td>
                  <td data-label="Вихід">{row.output.toFixed(3)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th scope="row">Разом</th>
                <td data-label="Брутто">{totals.grossWeight.toFixed(3)}</td>
                <td data-label="Нетто / шт.">{totals.netWeight.toFixed(3)}</td>
                <td data-label="Вихід">{totals.output.toFixed(3)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </section>
  );
};

export default RecipeCalculationCard;
